import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSongkickComponent } from './simple-icons-songkick.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSongkickComponent ],
    exports:      [ SimpleIconsSongkickComponent ],
    bootstrap:    []
})
export class SimpleIconsSongkickModule {}
